export class ResponseError {
    public field: string;
    public label: string;

    public constructor(field: string, label: string) {
        this.field = field;
        this.label = label;
    }
}
